import RegistrationTypeEnum from "@/enums/RegistrationTypeEnum";
import { RegistrationState } from "./RegistrationState";
import { RegStateRegister } from "./RegStateRegister";
import { RegStateActivation } from "./RegStateActivation";
import { RegStateResetPassword } from "./RegStateResetPassword";

/** Etat : Traitement de l'analyse du token */
export class RegStateInit extends RegistrationState {
    public async Next(): Promise<void> {
        console.debug("Registration : State Init %0" ,this.analyseToken);

        /** Affiche le formulaire */
        this.context.ShowForm = true;

        switch(this.analyseToken.Type){
            case RegistrationTypeEnum.Registration:
                this.context.TransitionTo(new RegStateRegister(this))
                break;
            case RegistrationTypeEnum.Activation:
                this.context.TransitionTo(new RegStateActivation(this))
                break;
            case RegistrationTypeEnum.ResetPassword:
                this.context.TransitionTo(new RegStateResetPassword(this))
                break;
            default:
        }
        await this.context.Next();
    }
}